@if (showHeader) {
  <div class="cw-card-header">
    <div class="cw-card-wrapper">
      <div class="d-flex flex-column">
        <div class="cbw-card-title">
          {{ title }}
      </div>
      <div class="cbw-card-subtitle">{{ subtitle }}</div>
      </div>
      <app-reservation-countdown
        [showReservationCountdown]="showReservationCountdown"
        [partner]="partner"
        [cart]="cart"
      />
    </div>
  </div>
  <hr class="cw-card-divider">
}
